// extracted by mini-css-extract-plugin
module.exports = {"skipContentLinkEW":"SkipContentLink_skipContentLinkEW__2felc"};